<div class="filter-buttons-container" *ngIf="elementId">
  <button
    mat-icon-button
    class="button-position"
    (click)="genericGrid.clearFilters()"
    [matTooltip]="'common.clear-grid-filter' | translate | lowercase"
  >
    <mat-icon class="material-icons-outlined" svgIcon="reset-grid"></mat-icon>
  </button>

  <button
    mat-icon-button
    (click)="setSeverityColors()"
    [matTooltip]="T_SCOPE + '.enable-disable-severity-colors' | translate | lowercase"
  >
    <mat-icon
      svgIcon="invert-colors"
      [ngClass]="{ flip: severityColorsToggle === false }"
    ></mat-icon>
  </button>
  <wlm-export-excel-button
    [visibleColumns]="gridSettings?.gridColumnSettings"
    [grid]="genericGrid"
  ></wlm-export-excel-button>
</div>

<wlm-generic-grid
  *ngIf="elementId"
  class="wtr-fx-flex-grow"
  [gridSettings]="gridSettings"
  [useCellStyle]="severityColorsToggle"
  [gridFiltersForBinding]="filters"
  [(selectedItems)]="selectedsAlarms"
></wlm-generic-grid>
